import {CSSProperties} from "react";

export interface SpaceProps {
    pt?: string | number;
    pb?: string | number;
    ptm?: string | number;
    pbm?: string | number;
}

export interface MarginProps {
    mt?: string | number;
    mb?: string | number;
    mtm?: string | number;
    mbm?: string | number;
}

function toCssVars<T extends object>(obj: T): CSSProperties {
    return Object.fromEntries(
        Object.entries(obj)
            .filter(([_, v]) => v !== undefined)
            .map(([k, v]) => [`--${k}`, String(v)]),
    ) as CSSProperties;
}

export function useSectionSpace(space: SpaceProps = {}): CSSProperties {
    return toCssVars(space);
}

export function getSectionSpace(space: SpaceProps = {}): CSSProperties {
    return toCssVars(space);
}

export function getSectionMargin(margin: MarginProps = {}): CSSProperties {
    return toCssVars(margin);
}
